import { NET_ID } from "@/config";
// import { get } from ".";
import { cdnUrl } from "@/utils/cdn";

export const BNBINFO = {
  chainId: NET_ID,
  decimals: 18,
  symbol: "BNB",
  name: "Binance Chain Native Token",
  isNative: true,
  isToken: false,
  // "address": "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd", //WBNB
  address: "BNB Chain Native Token", // 主网时使用
  logoURI: "/img/bsc/logo.webp",
};

export const BASEINFO = {
  chainId: NET_ID,
  decimals: 18,
  symbol: "BASE_ETH",
  name: "BASE Chain Native Token",
  isNative: true,
  isToken: false,
  address: "BASE Chain Native Token", // 主网时使用
  logoURI: "/img/base/logo.webp",
};

export const SUIINFO = {
  // chainId: NET_ID,
  decimals: 9,
  symbol: "SUI",
  name: "SUI",
  isNative: true,
  isToken: false,
  // "address": "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd", //WBNB
  address: "0x2::sui::SUI", // 主网时使用
  logoURI: "/img/chains/sui.svg",
};

// 根据链id返回平台原生币信息
export function getNativeTokenInfo() {
  // console.log("getNativeTokenInfo");
  switch (NET_ID) {
    case 56:
    case 97:
      BNBINFO.logoURI = cdnUrl(BNBINFO.logoURI);
      return BNBINFO;
    case 8453:
    case 84532:
      BASEINFO.logoURI = cdnUrl(BASEINFO.logoURI);
      return BASEINFO;
    default:
      SUIINFO.logoURI = cdnUrl(SUIINFO.logoURI);
      return SUIINFO;
  }
}
